import axios from "axios";
import React from "react";
import { useState } from "react";
import { API_BASE_URL } from "../../api/endPoint";
import get from "../../features/get";

export default function AddTeam({ modal }) {
  function handleClose() {
    modal(false);
  }
  const data = get?.Getusers();
  const [name, setName] = useState(null);
  const [description, setDescription] = useState(null);
  const [abbreviation, setAbbreviation] = useState(null);
  const [capitan, setCapitan] = useState(null);
  const [manager, setManager] = useState(null);
  const [image, setImage] = useState({ preview: "", data: "" });

  const handleChange = function loadFile(e) {
    const img = {
      preview: URL.createObjectURL(e.target.files[0]),
      data: e.target.files[0],
    };
    setImage(img);
  };
  const teams = get.Getteam();
  let lastindex = teams && teams?.length - 1;
  let team_id = teams && teams[lastindex]?.id + 1;
  let team = {
    name,
    description,
    abbreviation,
    capitanId: capitan,
    managerId: manager,
    logo: image?.data,
    team_id,
  };
  const handleCreate = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}create/team/`, team, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => console.log(res, "back end response"))
      .catch((err) => console.log(err, "error back end response"));
  };

  console.log(team, "teams");
  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      onClick={handleClose}
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
          >
            <div className="">
              <h1 className="py-2 px-5">Create Team</h1>
            </div>
            <form onSubmit={handleCreate}>
              <div className="grid justify-center">
                <div className="inline-block relative justify-center flex-col gap-2 mb-2">
                  <div id="camera--icon">
                    <span className="text-[#797979] text-[12px] text-center">
                      {image?.preview == "" ? "Please select Team image" : ""}
                      <input
                        name="Select File"
                        type="file"
                        onChange={handleChange}
                        accept="image/*"
                      ></input>
                      {image?.preview !== "" ? (
                        <img
                          className="max-w-[200px] h-[200px] rounded-md"
                          src={image?.preview}
                          alt="image description"
                        />
                      ) : (
                        <img
                          className="max-w-[200px] h-[200px] rounded-md "
                          src="https://flowbite.com/docs/images/examples/image-1@2x.jpg"
                          alt="image description"
                        />
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="grid grid-cols-12 gap-3">
                  <div className="col-span-6">
                    {" "}
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Name
                    </label>
                    <input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      id="first_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Name"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    {" "}
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Abbreviation
                    </label>
                    <input
                      onChange={(e) => setAbbreviation(e.target.value)}
                      type="text"
                      id="first_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Abbreviation"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="capitan"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Select team Capitan
                    </label>
                    <select
                      onChange={(e) => setCapitan(e.target.value)}
                      id="capitan"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option selected>Choose a Capitan</option>
                      {data?.map((items) => (
                        <option value={items?.id}>
                          {items?.firstname + " " + items?.lastname}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-6">
                    <label
                      for="Manager"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Select team Manager
                    </label>
                    <select
                      onChange={(e) => setManager(e.target.value)}
                      id="Manager"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option selected>Choose a Manager</option>
                      {data?.map((items) => (
                        <option value={items?.id}>
                          {items?.firstname + " " + items?.lastname}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <label
                    for="last_name"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Description
                  </label>
                  <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    type="text"
                    id="description"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Description"
                  >
                    {description}
                  </textarea>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="submit"
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-[#67e8f9] px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-[#22d3ee] focus:outline-none focus:ring-2 focus:ring-[#22d3ee] focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Create
                </button>
                <button
                  onClick={handleClose}
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
